import React from 'react'
import T from 'prop-types'
import { Box, Divider, Typography } from '@mui/material'

export default function CarDetailsList({ title, children, columns = 1 }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="body1" color="textPrimary">
        <strong>{title}</strong>
      </Typography>
      <Divider sx={{ my: 1 }} />
      <Box
        sx={
          columns > 1
            ? {
                display: 'grid',
                gridTemplateColumns: `repeat(${columns}, 1fr)`,
                columnGap: 3,
              }
            : undefined
        }
      >
        {children}
      </Box>
    </Box>
  )
}

CarDetailsList.propTypes = {
  title: T.string,
  items: T.array,
}
